import { PaginationDataProps, PromiseResponseProps } from "@/config/types/common";
import request from "@/utils/request";

export function hardshipApply(data: {
  realName: string;
  userId: string;
  gongHuiId: string;
  gongHuiName: string;
  phone: string;
  applyDesc: string;
}): PromiseResponseProps<null> {
  return request({
    url: "/care_center/v1/hardship_apply",
    method: "post",
    data,
  });
}

export function hardshipApplyrRecords(data: {
  pageNum: number;
  pageSize: number;
}): PromiseResponseProps<
  PaginationDataProps<{
    content: string;
    applyStatus: number;
    applyStatusDesc: string;
    rejectReason: string;
  }>
> {
  return request({
    url: "/care_center/v1/apply_records",
    method: "post",
    data,
  });
}
